import AgiliteUtils from 'agilite-utils'

import MemoryStore from '../utils/memory-store'
import { cleanupObject, updateArrayDataFromSave } from '../utils/utilities'
import { postData } from '../core/core-utils'
import { formatRecord } from './events-utils'
import Enums from '../utils/enums'

/*
  ENUMS
*/
export const actions = {
  RESET_STATE: 'RESET_STATE_EVENTS',
  CREATE_PROFILE: 'CREATE_PROFILE_EVENTS',
  SAVE_PROFILE: 'SAVE_PROFILE_EVENTS',
  CANCEL_PROFILE: 'CANCEL_PROFILE_EVENTS',
  EDIT_PROFILE: 'EDIT_PROFILE_EVENTS',
  DELETE_PROFILE: 'DELETE_PROFILE_EVENTS',
  FETCH_ALL_DATA: 'FETCH_ALL_DATA_EVENTS',
  SET_SEARCH_FILTER: 'SET_SEARCH_FILTER_EVENTS',
  UPDATE_DATA: 'UPDATE_DATA_EVENTS'
}

/*
  DISPATCH FUNCTIONS
*/
export const setSearchFilter = (value) => {
  return {
    type: actions.SET_SEARCH_FILTER,
    value
  }
}

export const updateData = (data) => {
  return {
    type: actions.UPDATE_DATA,
    data
  }
}

export const saveProfile = (appId, recordId, state, callback) => {
  return async (dispatch) => {
    const entry = MemoryStore.activeEntries[recordId]
    const combinedKeysArray = []
    const headers = {}
    let reqType = ''
    let tempArray = state.data.concat()
    let result = true
    let errMsg = null

    // Cleanup and Trim
    cleanupObject(entry.data)
    await AgiliteUtils.trimObjectValues(entry.data)

    // Validation
    if (entry.data.key === '') {
      errMsg = 'Please provide an Event Key'
      return callback(errMsg)
    }

    // Loop through existing data and create new array with key and linkedProfile combined
    state.data.map((tmpEntry) => {
      if (tmpEntry._id !== entry._id) {
        combinedKeysArray.push(`${tmpEntry.data.key}-${tmpEntry.data.linkedProfile}`)
      }
      return null
    })

    // Duplicate Check
    combinedKeysArray.map((combinedKey) => {
      if (combinedKey === `${entry.data.key}-${entry.data.linkedProfile}`) {
        result = false
      }
      return null
    })

    if (!result) {
      errMsg = `Entry '${entry.data.key}-${entry.data.linkedProfile}' is already being used`
      return callback(errMsg)
    }

    // Post Data to Agilit-e
    tempArray = formatRecord(entry, tempArray)
    reqType = entry.custom.action === 'create' ? 'post' : 'put'

    // Create Headers Object
    headers['record-id'] = recordId

    postData(appId, reqType, entry, headers)
      .then((response) => {
        callback(null)

        entry.custom.action = ''
        entry.custom.isSavedDoc = true
        entry.key = response.data._id
        entry._id = response.data._id
        entry.data.isActiveDescription = response.data.data.isActive ? 'Yes' : 'No'

        // Dispatch New Array
        tempArray = updateArrayDataFromSave(entry, tempArray)
        dispatch({ type: actions.UPDATE_DATA, data: tempArray })
      })
      .catch((error) => {
        console.log(error)

        if (error.response) {
          callback(error.response.data.errorMessage)
        } else {
          callback(Enums.MESSAGES.UNKNOWN_ERROR)
        }
      })
  }
}
